/** Reloads the page. A module of its own so tests can stand in for it: jsdom's location cannot be stubbed. */
export const reloadPage = (): void => {
  window.location.reload();
};
